/* eslint-disable no-undef */
// src/polyfills.js
// garante global e performance.now no browser
if (typeof globalThis.performance?.now !== 'function') {
  // fallback muito antigo (quase nunca necessário)
  globalThis.performance = { now: () => Date.now() };
}
if (typeof global === 'undefined') {
  // torna 'global' um alias para globalThis
  // eslint-disable-next-line no-undef
  window.global = globalThis;
}
//
